// `rawJSON` wraps a digit string so `JSON.stringify` emits it verbatim.
// Typed by `src/core-js-raw-json.d.ts` until TypeScript ships the API.
import rawJSON from "core-js/actual/json/raw-json";

/**
 * `JSON.stringify` replacer that emits every `bigint` as a raw JSON integer
 * (`{"min_file_timestamp_ns": 1719878400123456789}`). The default stringify
 * throws `TypeError` on bigint, and converting through `Number` would
 * silently round ns-epoch values past `Number.MAX_SAFE_INTEGER`.
 *
 * Write-side counterpart of `parseTimestampsAsBigInt`. It matches on the
 * value's type, not its key, so it keeps no key list of its own; the two
 * round-trip a value only under a key the reviver allowlists. A `bigint` under
 * any other key goes out at full precision and comes back a rounded `Number`.
 *
 * https://github.com/tc39/proposal-json-parse-with-source
 */
export function bigintReplacer(_key: string, value: unknown): unknown {
  return typeof value === "bigint" ? rawJSON(value.toString()) : value;
}
